module.exports = __webpack_public_path__ + "static/media/06A.4a2906e1.png";